<template>
  <div class="mb-2 text-left">
    <span>
      <Tooltip
        v-if="data.helpTxt"
        :help-text="data.helpTxt"
        :help-id="data.key + '-' + index"
        :label="data.key"
      />
      <h4 class="font-weight-bold">{{ data.key }}</h4>
    </span>
    <span v-if="data.count" class="badge badge-primary ml-2">
      <template v-if="showRange">
        {{ data.displayFrom }}-{{ data.displayTo }} of {{ data.displayTotal }}
      </template>
      <template v-else>
        <span v-if="data.maxShow">{{ data.maxShow }} / </span>{{ data.count }}
      </template>
      <span>{{ data.entry_name || "entries" }}</span>
    </span>
  </div>
</template>

<script>
import Tooltip from "@/components/common/Tooltip.vue";
export default {
  components: { Tooltip },
  mounted() {},
  props: ["data", "index"],
  computed: {
    // TAIR3-1041: the page range counts table rows. A section whose count is
    // something else (GO/PO "unique annotations" from the annotation search,
    // shown over a summary table) sets hideRange to show the count instead.
    showRange() {
      return this.data.displayFrom != null && !this.data.hideRange;
    },
  },
};
</script>
<style scoped>
.text-left {
  text-align: left;
}
.badge-primary {
  background-color: #0c335d;
}
</style>
